import {
  CheckOutlined,
  CloseOutlined,
  DownloadOutlined,
  PlusOutlined,
  SendOutlined,
  UserOutlined,
} from "@ant-design/icons";
import AssessmentIcon from "@mui/icons-material/Assessment";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcCallIcon from "@mui/icons-material/AddIcCall";
import { IconButton } from "@mui/material";
import {
  Button,
  Divider,
  Input,
  message,
  Modal,
  Popconfirm,
  Select,
  Space,
  Spin,
  Tag,
  Tooltip,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import { toJalaali } from "jalaali-js";
import React, { useEffect, useRef, useState } from "react";
import jalali from "react-date-object/calendars/jalali";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import api from "../../../api/api";
import DataTable from "../../../Components/DataTable/DataTable";
import OperatorSelector from "../../../Components/OperatorSelector/OperatorSelector";
import * as actions from "../../../store/actions/action";
import CheckPermission from "../../../Util/CheckPermission";
import ConvertNumbersToEn from "../../../Util/ConvertNumbersToEn";
import { dataFetchError } from "../../../Util/Messages";
import InstallmentCallsReportModal from "../../../Components/InstallmentCallsReportModal/InstallmentCallsReportModal";
import { downloadRoadmapCallsExcel } from "../../../Util/RoadmapCallsExcel";

const Roadmaps = ({ ClearLoading, LoadingSetter, permissions, role }) => {
  const [operators, setOperators] = useState(null);
  const [editableKeys, setEditableRowKeys] = useState();
  const [statModal, setStatModal] = useState(false);
  const [callReport, setCallReport] = useState(null);
  const [callReportModal, setCallReportModal] = useState(false);
  const [data, setData] = useState();
  const [pagination, setPagination] = useState({});
  const [publishers, setPublishers] = useState([]);

  const [loadingData, setLoadingData] = useState(false);
  const [exportingCalls, setExportingCalls] = useState(false);
  const exportingCallsRef = useRef(false);
  const [items, setItems] = useState(["بلاگر", "پلنیوم"]);
  const [name, setName] = useState("");
  const [showEpollForms, setShowEpollForms] = useState(true);
  const [tempCallNote, setTempCallNote] = useState("");
  const inputRef = useRef(null);
  const operatorSelectModal = useRef(null);
  const callsReportRef = useRef(null);

  const addItem = (e) => {
    e.preventDefault();
    setItems([...items, name || `تگ جدید`]);
    setName("");
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  const filtersBeautify = (fData) => {
    const filters = {
      ...(typeof fData.renewal?.at(0) === "boolean"
        ? { renewal: fData.renewal?.at(0) }
        : {}),
      ...(fData.tag?.at(0) ? { tag: fData.tag?.at(0) } : {}),
      ...(fData.mobile?.at(0)
        ? { phone: ConvertNumbersToEn(fData.mobile?.at(0)) }
        : {}),
      ...(fData.country_code?.at(0)
        ? { countryCode: ConvertNumbersToEn(fData.country_code?.at(0)) }
        : {}),
      ...(fData.name?.at(0) ? { name: fData.name?.at(0) } : {}),
      ...(fData.fname?.at(0) ? { fname: fData.fname?.at(0) } : {}),
      ...(fData.product_private_title?.at(0)
        ? { productCode: fData.product_private_title?.at(0) }
        : {}),
      ...(fData.status?.at(0) ? { status: fData.status?.at(0) } : {}),
      ...(typeof fData.autoPublish?.at(0) === "boolean"
        ? { autoPublish: fData.autoPublish?.at(0) }
        : {}),
      ...(fData.publisher?.at(0) ? { publisher: fData.publisher?.at(0) } : {}),
      ...(fData.assigned_to?.at(0)
        ? { assignedTo: fData.assigned_to?.at(0) }
        : {}),
    };

    for (const stat of fData?.call_status ?? []) {
      if (stat === "HAS_NOTE") {
        filters.hasNote = true;
        continue;
      }

      const spliced = stat.split("_");
      filters[spliced.at(0)] = spliced.slice(1).join("_").replace(/-/g, "_");
    }

    return filters;
  };

  const closeCallReport = () => {
    setCallReport(null);
    setCallReportModal(false);
  };
  const changeCallReportValues = (field, newVal) => {
    setCallReport((prev) => ({ ...prev, [field]: newVal }));
  };
  const getCompletedCount = () => {
    return data?.filter((record) => {
      const status = statusMapper(record?.status);

      return status === "تکمیل شده";
    })?.length;
  };
  const getUnCompletedCount = () => {
    return data?.filter((record) => {
      const status = statusMapper(record?.status);

      return status !== "تکمیل شده";
    })?.length;
  };
  const getSaleLastDay = () => {
    return data?.filter((record) => {
      const lastDay = 24 * 3600 * 1000;
      const dd = new Date(record?.submittedAt);

      return new Date() - dd < lastDay;
    })?.length;
  };
  const getSaleLastWeek = () => {
    return data?.filter((record) => {
      const lastDay = 7 * 24 * 3600 * 1000;
      const dd = new Date(record?.submittedAt);

      return new Date() - dd < lastDay;
    })?.length;
  };
  const getSaleLastMonth = () => {
    return data?.filter((record) => {
      const lastDay = 30 * 24 * 3600 * 1000;
      const dd = new Date(record?.submittedAt);

      return new Date() - dd < lastDay;
    })?.length;
  };

  const changeCallStatusHandler = (key, call_status) => {
    api
      .put("/roadmaps/interview", { call_status, key })
      .then(() => {
        message.success("با موفقیت انجام شد");
        setData((prev) =>
          prev.map((el) => {
            if (el.key !== key) return el;

            return { ...el, call_status };
          }),
        );
      })
      .catch(() => message.error("خطا در ثبت گزارش تماس"))
      .finally(() => closeCallReport());
  };

  const changeCallReportHandler = () => {
    api
      .put("/roadmaps/interview", callReport)
      .then(() => {
        message.success("ثبت با موفقیت انجام شد");
        setData((prev) =>
          prev.map((el) => {
            if (el.id !== callReport.id) return el;

            return callReport;
          }),
        );
      })
      .catch(() => message.error("خطا در ثبت گزارش تماس"))
      .finally(() => closeCallReport());
  };

  const lastQueryRef = useRef({ page: 1, pageSize: 100, filter: undefined });

  const exportCalls = async () => {
    if (exportingCallsRef.current || !CheckPermission("roadmaps_export_calls_excel", permissions)) return;
    exportingCallsRef.current = true;
    setExportingCalls(true);
    const epoll = showEpollForms;
    const filters = { ...lastQueryRef.current.filter };
    try {
      const downloaded = await downloadRoadmapCallsExcel(api, { filters, epoll });
      if (!downloaded) {
        message.info("نقشه راهی برای خروجی اکسل وجود ندارد.");
        return;
      }
    } catch (error) {
      message.error("خطا در دریافت خروجی اکسل تماس‌ها؛ دوباره تلاش کنید.");
    } finally {
      exportingCallsRef.current = false;
      setExportingCalls(false);
    }
  };

  const loadData = (page = 1, pageSize = 100, filter) => {
    lastQueryRef.current = { page, pageSize, filter };
    setLoadingData(true);
    LoadingSetter();
    api
      .get("/roadmaps/unpublishroadMaps", {
        params: { page, pageSize, ...filter, epoll: showEpollForms },
      })
      .then((res) => {
        const data = res.data.roadmaps
          .filter((el) => el)
          // .reverse()
          .map((el) => ({
            name: el.users_permissions_user.firstname,
            fname: el.users_permissions_user.lastname,
            mobile: el.users_permissions_user.username,
            country_code: el.users_permissions_user.country_code,
            prev_roadmap: el.prev_roadmap,
            renewal: el.renewal ?? false,
            installment_tracking_calls: el.installment_tracking_calls,
            autoPublish: el.auto_publish ?? false,
            submittedAt: el.form_answered ?? el?.epoll_response?.updatedAt ?? el.order_created_at,
            formAnsweredAt: el.form_answered,
            orderCreatedAt: el.order_created_at,
            publishedAt: el.publishedAt,
            id: el.id,
            status: el.status,
            key: el.key,
            epollId: el.epoll_response != null && el.epoll_response.id,
            product_title: el.product_title,
            paid_as_installment: el?.paid_as_installment,
            product_private_title: el.product_private_title,
            product_code: el.product_code,
            // publisher: el.publisher,
            publisher: el?.publisher
              ? `${el?.publisher?.firstname} ${el?.publisher?.lastname}`
              : null,
            // assigned_to: el.assigned_to,
            assigned_to: el?.assigned_to
              ? `${el?.assigned_to?.firstname} ${el?.assigned_to?.lastname}`
              : null,
            tag: el.tag,
            call_status: el.call_status,
            product_consent_type: el.product_consent_type,
            problem: el.problem,
            expectation: el.expectation,
            referral_source: el.referral_source,
            idea: el.idea,
            second_roadmap_reason: el.second_roadmap_reason,
            renewal_duplicate_content: el.renewal_duplicate_content,
            refund_status: el.refund_status,
            refund_card_number: el.refund_card_number,
            refund_date: el.refund_date,
            refund_price: el.refund_price,
            refund_tag: el.refund_tag,
            refund_summery: el.refund_summery,
          }));

        setData(data);
        setPagination(res.data.pagination);
        // setItems(
        //   Array.from(
        //     new Set([
        //       ...items,
        //       ...data.map((i) => i.refund_tag).filter((a) => a),
        //     ])
        //   )
        // );
        ClearLoading();
      })
      .catch(() => {
        ClearLoading();
        dataFetchError();
      })
      .finally(() => setLoadingData(false));

    api.get("/roadmapeditors").then((res) => setOperators(res.data));
  };

  const columns = [
    // {
    //   title: "نام و نام خانوادگی",
    //   dataIndex: "name",
    //   width: "7%",
    //   searchable: true,
    //   render: (ـ, record) => {
    //     return (
    //       <span
    //         onClick={() => {
    //           navigator.clipboard.writeText(record?.name);
    //           message.success("نام در کلیپ بورد کپی شد");
    //         }}
    //       >
    //         {record?.name}
    //       </span>
    //     );
    //   },
    // },
    {
      title: "نام",
      dataIndex: "name",
      width: "7%",
      searchable: true,
      render: (ـ, record) => {
        return (
          <span
            onClick={() => {
              navigator.clipboard.writeText(record?.name);
              message.success("نام در کلیپ بورد کپی شد");
            }}
          >
            {record?.name}
          </span>
        );
      },
    },
    {
      title: "نام خانوادگی",
      dataIndex: "fname",
      width: "7%",
      searchable: true,
      render: (ـ, record) => {
        return (
          <span
            onClick={() => {
              navigator.clipboard.writeText(record?.fname);
              message.success("نام خانوادگی در کلیپ بورد کپی شد");
            }}
          >
            {record?.fname}
          </span>
        );
      },
    },
  ];

  const statusMapper = (status) => {
    if (!status || status === "UN_COMPLETED") {
      return "تکمیل نشده";
    }
    if (status === "COMPLETED") return "تکمیل شده";
    if (status === "SUPERVISOR_CHECK") return "چک سوپروایزر";
    return status;
  };

  const publish = (epollresponseId) => {
    api
      .post("/roadmaps/publish", { epollresponseId })
      .then(() => message.success("نقشه راه منتشر شد"))
      .catch(() => message.error("انتشار نقشه راه با مشکل مواجه شد."))
      .finally(() => {
        const { page, pageSize, filter } = lastQueryRef.current;
        loadData(page, pageSize, filter);
      });
  };

  if (CheckPermission("show_phone_number", permissions)) {
    columns.push({
      title: "موبایل",
      dataIndex: "mobile",
      width: "7%",
      // defaultSortOrder: "ascend",
      searchable: true,
      render: (text, record) => {
        return (
          <span
            onClick={() => {
              navigator.clipboard.writeText(record?.mobile);
              message.success("شماره موبایل در کلیپ بورد کپی شد");
            }}
          >
            {record?.mobile}
          </span>
        );
      },
    });

    columns.push({
      title: "کد کشور",
      dataIndex: "country_code",
      width: "4%",
      searchable: true,
      render: (text, record) => {
        return <span dir="ltr">{record?.country_code || "98"}</span>;
      },
    });
  }

  useEffect(() => loadData(), [showEpollForms]);

  // useEffect(() => {
  //   if (!Array.isArray(data)) return;

  //   const uniquePublishers = [];
  //   const uniquePublishersId = new Set();
  //   data?.forEach((el) => {
  //     if (el?.publisher?.id && !uniquePublishersId.has(el?.publisher?.id)) {
  //       uniquePublishers.push({
  //         text: `${el?.publisher?.firstname} ${el?.publisher?.lastname}`,
  //         value: el?.publisher?.id,
  //       });
  //     }
  //   });
  //   setPublishers(uniquePublishers);
  // }, [data]);

  // tag
  columns.push({
    title: "تگ",
    dataIndex: "tag",
    width: "5%",
    searchable: true,
    render: (_, record) => {
      return <span>{record?.tag === "" ? "-" : record?.tag}</span>;
    },
  });
  // renewal
  columns.push({
    title: "نقشه جدید",
    width: "4%",
    filterMultiple: false,
    dataIndex: "renewal",
    filters: [
      { text: "بله", value: true },
      { text: "خیر", value: false },
    ],

    render: (text, record) => {
      if (!record.renewal) {
        return <CloseOutlined style={{ color: "red" }} />;
      }
      return record.prev_roadmap?.key ? (
        <Link to={`/user-roadmap/${record.prev_roadmap.key}`}>
          <CheckOutlined style={{ color: "green" }} />
        </Link>
      ) : (
        <CheckOutlined style={{ color: "green" }} />
      );
    },
  });
  // product
  columns.push({
    title: "محصول",
    width: "7%",
    filterMultiple: false,
    dataIndex: "product_private_title",
    // defaultSortOrder: "ascend",
    // onFilter: (value, record) => record.product_private_title === value,

    // filters: Array.from(
    //   new Set((data ?? []).map((e) => e?.product_private_title))
    // ).map((e) => ({ text: e, value: e })),

    filters: [
      { text: "نقشه راه روان‌شناسی", value: "roadmap-psychology" },
      { text: "نقشه راه لایف کوچ", value: "roadmap-3" },
      { text: "نقشه راه عمران", value: "roadmap-civil" },
    ],

    render: (text, record) => {
      return (
        <span title={record.product_code}>{record.product_private_title}</span>
      );
    },
  });
  // submittedAt
  columns.push({
    title: "تاریخ درخواست",
    width: "5%",
    dataIndex: "submittedAt",
    // defaultSortOrder: "ascend",
    // sorter: (a, b) => {
    //   const Adate = new Date(a.submittedAt);
    //   const Bdate = new Date(b.submittedAt);

    //   return Bdate - Adate;
    // },
    render: (text, record) => {
      try {
        const rawDate = record?.formAnsweredAt ?? text;
        const isPaymentFallback = !rawDate && record?.orderCreatedAt;
        const dateValue = rawDate || record?.orderCreatedAt;
        if (!dateValue) return "—";
        const date = new Date(dateValue);
        if (isNaN(date.getTime())) return "—";
        const jalali = toJalaali(
          date.getFullYear(),
          date.getMonth() + 1,
          date.getDate(),
        );
        return (
          <span
            dir="ltr"
            style={isPaymentFallback ? { color: "#999" } : undefined}
          >
            {jalali.jy}-{jalali.jm}-{jalali.jd}{" "}
            {date.toLocaleTimeString("eo", { hour12: false })}
          </span>
        );
      } catch (error) {
        console.log("error in submittedAt", { record, error });
        return "—";
      }
    },
  });
  //publishedAt
  columns.push({
    title: "تاریخ انتشار",
    dataIndex: "publishedAt",
    // searchable: true,
    width: "6%",
    // sorter: (a, b) => {
    //   const Adate = new Date(a.publishedAt).getTime();
    //   const Bdate = new Date(b.publishedAt).getTime();
    //   return Bdate - Adate;
    // },
    render: (text, record) => {
      try {
        if (text !== "-") {
          const date = new Date(text);
          const jalali = toJalaali(
            date.getFullYear(),
            date.getMonth() + 1,
            date.getDate(),
          );
          return (
            <span dir="ltr">
              {jalali.jy}-{jalali.jm}-{jalali.jd}{" "}
              {date.toLocaleTimeString("eo", { hour12: false })}
            </span>
          );
        } else {
          return <span>-</span>;
        }
      } catch (error) {
        console.log("error in publishedAt", { record, error });
        return "خطا";
      }
    },
  });
  // publisher
  columns.push({
    title: "منتشر کننده",
    dataIndex: "publisher",
    // filters: publishers ?? [],
    searchable: true,
    // onFilter: (value, record) => record?.publisher?.id === value,
    width: "7%",
  });
  // status
  columns.push({
    title: "وضعیت",
    dataIndex: "status",
    width: "5%",
    filterMultiple: false,
    // onFilter: (value, record) => {
    //   if (value === "UN_COMPLETED") {
    //     return record.status === value || !record.status;
    //   }

    //   return record.status === value;
    // },
    filters: [
      { text: statusMapper("COMPLETED"), value: "COMPLETED" },
      { text: statusMapper("UN_COMPLETED"), value: "UN_COMPLETED" },
      { text: statusMapper("SUPERVISOR_CHECK"), value: "SUPERVISOR_CHECK" },
    ],
    render: (obj, record) => {
      return <span>{statusMapper(record?.status)}</span>;
    },
  });
  // operator
  columns.push({
    title: "اپراتور",
    width: "8%",
    dataIndex: "assigned_to",
    filterMultiple: false,
    filters: Array.isArray(operators)
      ? [
          ...operators.map((el) => ({
            text: `${el.firstname} ${el.lastname}`,
            value: `${el.firstname} ${el.lastname}`,
          })),
          { text: "ندارد", value: "__NONE__" },
        ]
      : [],
    onFilter: (value, record) => {
      const assigned = record.assigned_to && record.assigned_to !== "-";
      if (value === "__NONE__") return !assigned;
      return assigned && record.assigned_to === value;
    },
    render: (assignedTo, record) => {
      const assigned = assignedTo && assignedTo !== "-";
      if (!CheckPermission("assign_roadmap", permissions)) {
        return <Tag>{assigned ? assignedTo : "ندارد"}</Tag>;
      }
      return (
        <Button
          onClick={() => {
            operatorSelectModal?.current?.open(record.id);
          }}
          type={assigned ? "primary" : "default"}
        >
          {assigned ? assignedTo : "تخصیص اپراتور"}
        </Button>
      );
    },
  });
  // call status
  columns.push({
    title: "وضعیت مصاحبه",
    width: "10%",
    dataIndex: "call_status",
    filters: [
      { text: "وضعیت تماس: در انتظار تماس", value: "callStatus_WAITING" },
      { text: "وضعیت تماس: موفق", value: "callStatus_SUCCESS" },
      { text: "وضعیت تماس: ناموفق", value: "callStatus_FAILED" },
      { text: "وضعیت تماس: آخرین مهلت", value: "callStatus_LAST_CHANCE" },
      { text: "وضعیت تماس: پایان مهلت", value: "callStatus_DEADLINE" },
      { text: "وضعیت تماس: بازگشت وجه", value: "callStatus_REFUND" },
      { text: "وضعیت تماس: شروع نکرده", value: "callStatus_NOT_STARTED" },
      {
        text: "وضعیت تماس: عدم امکان پاسخگویی",
        value: "callStatus_UNABLE_TO_RESPOND",
      },
      {
        text: "عدم پرداخت اقساط: بازگشت وجه",
        value: "callStatus_UNPAID_INSTALLMENT",
      },

      { text: "یادداشت دارد", value: "HAS_NOTE" },

      { text: "وضعیت مصاحبه: راضی", value: "interviewStatus_HAPPY" },
      { text: "وضعیت مصاحبه: ناراضی", value: "interviewStatus_UNHAPPY" },
      {
        text: "وضعیت مصاحبه: سفیر برند",
        value: "interviewStatus_BRAND-AMBASSADOR",
      },
      {
        text: "عدم پرداخت اقساط: وضعیت مصاحبه",
        value: "interviewStatus_UNPAID_INSTALLMENT",
      },
      {
        text: "وضعیت مصاحبه: درخواست بازگشت وجه",
        value: "interviewStatus_REFUND",
      },
      {
        text: "عدم پرداخت اقساط: بازگشت وجه",
        value: "callStatus_UNPAID_INSTALLMENT",
      },

      { text: "وضعیت بازگشت وجه: در انتظار", value: "refundStatus_WAIT" },
      { text: "وضعیت بازگشت وجه: انجام شد", value: "refundStatus_DONE" },

      {
        text: "وضعیت بازگشت وجه: در حال انجام",
        value: "refundStatus_IN-PROGRESS",
      },
      { text: "پرداخت اقساطی", value: "paid_INSTALLMENT" },
    ],
    // onFilter: (value, record) => {
    //   const group = value.split("_")?.at(0);
    //   const tempVal = value.replace(`${group}_`, "");

    //   if (value.startsWith("CALL_")) {
    //     if (record.call_status === tempVal && tempVal === "REFUND") return true;
    //     return (record.call_status ?? "WAITING") === tempVal;
    //   } else if (value.startsWith("TYPE_")) {
    //     return record.product_consent_type === tempVal;
    //   } else if (value.startsWith("REFUND_")) {
    //     return record.refund_status === tempVal;
    //   } else if (value === "HAS_NOTE") {
    //     return (record.refund_summery ?? "").trim() !== "";
    //   }

    //   return false;
    // },
    render: (_, r) => {
      const record = data.find((el) => el.id === r.id);

      if (
        !record.publishedAt &&
        record?.product_consent_type !== "REFUND" &&
        record?.call_status !== "REFUND" &&
        record?.call_status !== "UNPAID_INSTALLMENT"
      ) {
        return "-";
      }

      let color = "";
      const atLeastCalledOnce = record.installment_tracking_calls.some(
        (call) => call.calledAt,
      );

      if (record.call_status === "LAST_CHANCE") {
        color = "warning";
      } else if (record.call_status === "DEADLINE") {
        color = "error";
      }

      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "0.2rem",
          }}
        >
          <Select
            status={color}
            style={{ width: "80%" }}
            placeholder="وضعیت تماس"
            value={record.call_status ?? "WAITING"}
            onChange={(val) => changeCallStatusHandler(record.key, val)}
            options={[
              { label: "در انتظار تماس", value: "WAITING", disabled: true },
              { label: "موفق", value: "SUCCESS" },
              { label: "نا‌موفق", value: "FAILED" },
              { label: "عدم پرداخت اقساط", value: "UNPAID_INSTALLMENT" },
              { label: "بازگشت وجه", value: "REFUND" },
              { label: "شروع نکرده", value: "NOT_STARTED" },
              { label: "عدم امکان پاسخگویی", value: "UNABLE_TO_RESPOND" },
              {
                label: <span style={{ color: "orange" }}>آخرین مهلت</span>,
                value: "LAST_CHANCE",
                disabled: true,
              },
              {
                label: <span style={{ color: "red" }}>پایان فرصت</span>,
                value: "DEADLINE",
                disabled: true,
              },
            ]}
          />

          <IconButton
            onClick={() => {
              setCallReport(record);
              setCallReportModal(true);
            }}
            style={{
              backgroundColor:
                record?.refund_summery?.trim() ||
                record?.problem?.trim() ||
                record?.expectation?.trim() ||
                record?.referral_source?.trim() ||
                record?.idea?.trim()
                  ? "#3F96FE"
                  : "#F0F0F0",
              borderRadius: "0.5rem",
              padding: "0.3rem",
            }}
          >
            <MoreVertIcon fontSize="medium" />
          </IconButton>

          {/* installment call report */}
          {CheckPermission("submit_installment_calls_report", permissions) &&
            record?.paid_as_installment && (
              <IconButton
                onClick={() => {
                  callsReportRef.current.open(
                    record.id,
                    record.installment_tracking_calls ?? [],
                  );
                }}
                style={{
                  backgroundColor: atLeastCalledOnce ? "#3F96FE" : "#F0F0F0",
                  borderRadius: "0.5rem",
                  padding: "0.3rem",
                }}
              >
                <AddIcCallIcon fontSize="medium" />
              </IconButton>
            )}
        </div>
      );
    },
  });
  // auto publish
  columns.push({
    title: "انتشار اتومات",
    width: "4%",
    dataIndex: "autoPublish",
    filterMultiple: false,
    filters: [
      { value: true, text: "انتشار اتومات" },
      { value: false, text: "غیر فعال" },
    ],
    // onFilter: (value, record) => record.autoPublish === value,
    render: (_, record) => {
      return record.autoPublish ? (
        <Tag color="green">انتشار اتومات</Tag>
      ) : (
        <Tag color="red">غیر فعال</Tag>
      );
    },
  });

  useEffect(() => {
    if (callReportModal) {
      setTempCallNote(callReport?.refund_summery ?? "");
    }
  }, [callReportModal]);

  return (
    <div>
      <InstallmentCallsReportModal
        ref={callsReportRef}
        afterUpdate={(roadmapId, callReportData) => {
          setData((prev) =>
            prev.map((item) => {
              if (item.id !== roadmapId) return item;
              return { ...item, installment_tracking_calls: callReportData };
            }),
          );
        }}
      />
      <DataTable
        tableKey="roadmaps"
        operationAlign="right"
        showRowNumber
        hideErrorReport
        hideComment
        filtersBeautify={filtersBeautify}
        dynamicPagination
        recordsCount={pagination.total}
        header={{
          title: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "0.5rem",
                width: "100%",
              }}
            >
              <span style={{ display: "flex", alignItems: "center" }}>
                <p>نقشه راه ها</p>
                <Select
                  style={{ marginLeft: "1rem", marginRight: "1rem" }}
                  defaultValue={true}
                  value={showEpollForms}
                  onChange={(val) => setShowEpollForms(val)}
                  options={[
                    { label: "ایپل", value: true },
                    { label: "پلنیوم", value: false },
                  ]}
                />
                {CheckPermission("roadmaps_summary_report", permissions) && (
                  <Tooltip title="گزارشات">
                    <AssessmentIcon
                      onClick={() => setStatModal(true)}
                      fontSize="small"
                      style={{
                        marginRight: "0.5rem",
                        cursor: "pointer",
                      }}
                    />
                  </Tooltip>
                )}
              </span>
              {CheckPermission("roadmaps_export_calls_excel", permissions) && (
                <Button
                  icon={<DownloadOutlined />}
                  loading={exportingCalls}
                  disabled={loadingData || exportingCalls}
                  onClick={exportCalls}
                >
                  خروجی اکسل تماس‌ها
                </Button>
              )}
              {loadingData && <Spin size="small" />}
            </div>
          ),
          avatar: { icon: <UserOutlined />, size: "large" },
        }}
        editable
        keepPageOnSave
        columns={columns}
        dataSource={data?.map((record) => ({
          ...record,
          isWarning: record.status === "SUPERVISOR_CHECK",
          isRed:
            new Date() - new Date(record.submittedAt) > 24 * 3_600 * 1_000 &&
            record.status !== "COMPLETED",
        }))}
        setDataSource={setData}
        editableKeys={editableKeys}
        reload={loadData}
        setEditableRowKeys={setEditableRowKeys}
        operationExtra={(record, i) => {
          const showPublish =
            !record.publishedAt && record.status === "COMPLETED";
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "0.3rem",
              }}
            >
              <Link to={`/user-roadmap/${record.key}`}>
                <Button type="primary">نقشه دهی</Button>
              </Link>

              {showPublish && (
                <Popconfirm
                  onConfirm={() => publish(record.epollId)}
                  title="آیا از انتشار نقشه راه مطمئن هستید؟"
                >
                  <Button icon={<SendOutlined />}>انتشار</Button>
                </Popconfirm>
              )}
            </div>
          );
        }}
      />
      <OperatorSelector
        ref={operatorSelectModal}
        operators={operators}
        data={data}
        setData={setData}
      />
      {/* report modal */}
      <Modal
        title="گزارشات نقشه راه ها "
        open={statModal}
        destroyOnClose
        onCancel={() => setStatModal(!statModal)}
        onOk={() => setStatModal(!statModal)}
      >
        <div style={{ fontSize: "1rem", marginTop: "1.5rem" }}>
          تعداد تمام نقشه راه ها: {data?.length}
        </div>
        <div style={{ fontSize: "1rem", marginTop: "0.7rem" }}>
          تعداد تمام نقشه راه ها تکمیل شده: {getCompletedCount()}
        </div>
        <div style={{ fontSize: "1rem", marginTop: "0.7rem" }}>
          تعداد تمام نقشه راه ها تکمیل نشده: {getUnCompletedCount()}
        </div>
        <div style={{ fontSize: "1rem", marginTop: "0.7rem" }}>
          تعداد تمام نقشه راه ها درخواستی یک روز اخیر: {getSaleLastDay()}
        </div>
        <div style={{ fontSize: "1rem", marginTop: "0.7rem" }}>
          تعداد تمام نقشه راه ها درخواستی هفت روز اخیر: {getSaleLastWeek()}
        </div>
        <div style={{ fontSize: "1rem", marginTop: "0.7rem" }}>
          تعداد تمام نقشه راه ها درخواستی یک ماه اخیر: {getSaleLastMonth()}
        </div>
      </Modal>
      {/* call status modal */}
      <Modal
        title="گزارش مصاحبه"
        open={callReportModal}
        destroyOnClose
        onCancel={closeCallReport}
        onOk={changeCallReportHandler}
      >
        <p style={{ padding: "0", transform: "translateY(0.5rem)" }}>
          وضعیت مصاحبه:
        </p>
        <Select
          style={{ width: "100%" }}
          defaultValue={callReport?.product_consent_type}
          value={callReport?.product_consent_type}
          onChange={(val) =>
            changeCallReportValues("product_consent_type", val)
          }
          options={[
            { label: "راضی", value: "HAPPY" },
            { label: "ناراضی", value: "UNHAPPY" },
            { label: "سفیر برند", value: "‌BRAND_AMBASSADOR" },
            {
              label: "درخواست بازگشت وجه",
              value: "REFUND",
              disabled: callReport?.call_status !== "REFUND",
            },
          ]}
        />

        {/* renewal-only questions */}
        {callReport?.renewal && (
          <>
            <div style={{ marginTop: "1rem" }}>
              <p style={{ padding: "0", transform: "translateY(0.5rem)" }}>
                نقشه دوم رو دریافت کردین؟ چی شد که دومی رو گرفتین؟
              </p>
              <TextArea
                rows={3}
                value={callReport?.second_roadmap_reason ?? ""}
                onChange={(e) =>
                  changeCallReportValues(
                    "second_roadmap_reason",
                    e.target.value,
                  )
                }
              />
            </div>

            <div style={{ marginTop: "1rem" }}>
              <p style={{ padding: "0", transform: "translateY(0.5rem)" }}>
                در تمدید نقشه راه با محتوای تکراری رو به رو شدین؟
              </p>
              <TextArea
                rows={3}
                value={callReport?.renewal_duplicate_content ?? ""}
                onChange={(e) =>
                  changeCallReportValues(
                    "renewal_duplicate_content",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}

        {/* interview report */}
        <p style={{ padding: "0", transform: "translateY(0.5rem)" }}>
          یادداشت:
        </p>
        <TextArea
          rows={4}
          defaultValue={tempCallNote}
          onChange={(e) => {
            setTempCallNote(e.target.value);
            changeCallReportValues("refund_summery", e.target.value);
          }}
        />

        {/* extra details for selected interview type */}
        <div style={{ marginTop: "1rem" }}>
          <p style={{ padding: "0", transform: "translateY(0.5rem)" }}>
            مشکل یا ابهام:
          </p>
          <TextArea
            rows={3}
            value={callReport?.problem ?? ""}
            onChange={(e) => changeCallReportValues("problem", e.target.value)}
          />
        </div>

        <div style={{ marginTop: "1rem" }}>
          <p style={{ padding: "0", transform: "translateY(0.5rem)" }}>
            محصول چیزی کم داشت یا انتظار دیگه ای داشتین؟
          </p>
          <TextArea
            rows={3}
            value={callReport?.expectation ?? ""}
            onChange={(e) =>
              changeCallReportValues("expectation", e.target.value)
            }
          />
        </div>

        <div style={{ marginTop: "1rem" }}>
          <p style={{ padding: "0", transform: "translateY(0.5rem)" }}>
            از چه طریق آشنا شدین و چی ترغیبتون کرد که پلنیوم رو تهیه کنید؟
          </p>
          <TextArea
            rows={3}
            value={callReport?.referral_source ?? ""}
            onChange={(e) =>
              changeCallReportValues("referral_source", e.target.value)
            }
          />
        </div>

        <div style={{ marginTop: "1rem" }}>
          <p style={{ padding: "0", transform: "translateY(0.5rem)" }}>
            پیشنهاد یا ایده؟
          </p>
          <TextArea
            rows={3}
            value={callReport?.idea ?? ""}
            onChange={(e) => changeCallReportValues("idea", e.target.value)}
          />
        </div>

        {/* refund status */}
        {callReport?.product_consent_type === "REFUND" && (
          <div
            style={{
              minHeight: "10rem",
              border: "1px solid rgba(0,0,0,0.2)",
              marginTop: "2.5rem",
              borderRadius: "0.5rem",
              padding: "0.3rem",
            }}
          >
            {/* status */}
            <div style={{ transform: "translateY(-0.5rem)" }}>
              <p>وضعیت بازگشت وجه:</p>
              <Select
                style={{ width: "100%" }}
                placeholder="-"
                value={callReport?.refund_status}
                onChange={(val) => changeCallReportValues("refund_status", val)}
                options={[
                  { label: "انجام شد", value: "DONE" },
                  { label: "در انتظار انجام", value: "WAIT" },
                  { label: "در حال انجام", value: "IN_PROGRESS" },
                ]}
              />
            </div>

            {/* tag */}
            <div style={{ transform: "translateY(-0.5rem)" }}>
              <p>تگ:</p>
              <Select
                value={callReport?.refund_tag}
                onChange={(e) => changeCallReportValues("refund_tag", e)}
                style={{ width: "100%" }}
                placeholder="تگ"
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    <Divider style={{ margin: "8px 0" }} />
                    <Space style={{ padding: "0 8px 4px" }}>
                      <Input
                        placeholder="افزودن تگ جدید"
                        ref={inputRef}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        onKeyDown={(e) => e.stopPropagation()}
                      />
                      <Button
                        type="text"
                        icon={<PlusOutlined />}
                        onClick={addItem}
                      >
                        افزودن
                      </Button>
                    </Space>
                  </>
                )}
                options={items.map((item) => ({
                  label: item,
                  value: item,
                }))}
              />
            </div>

            {/* buy price */}
            <div style={{ transform: "translateY(-0.5rem)", zIndex: 100 }}>
              <p>مبلغ پرداختی:</p>
              <Input
                type="number"
                value={callReport?.refund_price}
                onChange={(e) =>
                  changeCallReportValues("refund_price", e.target.value)
                }
              />
            </div>

            {/* card number */}
            <div style={{ transform: "translateY(-0.5rem)" }}>
              <p>شماره کارت:</p>
              <Input
                value={callReport?.refund_card_number ?? ""}
                onChange={(e) =>
                  changeCallReportValues("refund_card_number", e.target.value)
                }
              />
            </div>

            {/* date */}
            <div
              style={{
                transform: "translateY(-0.5rem)",
              }}
            >
              <p>تاریخ بازگشت وجه:</p>
              <DatePicker
                value={
                  callReport.refund_date
                    ? new Date(callReport.refund_date)
                    : null
                }
                style={{ width: "28rem" }}
                format="HH:mm - YYYY/MM/DD"
                onChange={(d) =>
                  changeCallReportValues("refund_date", new Date(d.toDate()))
                }
                calendar={jalali}
                locale={persian_fa}
                plugins={[<TimePicker position="left" />]}
                render={(value, openCalendar) => {
                  return (
                    <Input
                      value={value}
                      onClick={openCalendar}
                      style={{ width: "28.5rem" }}
                    />
                  );
                }}
              />
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.loading,
    error: state.error,
    permissions: state.userData ? state.userData.permissions : null,
    role: state.userData ? state.userData.role : null,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ClearError: () => dispatch(actions.ClearError()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
    LoadingSetter: () => dispatch(actions.LoadingSetter()),
    ErrorSetter: () => dispatch(actions.ErrorSetter()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Roadmaps);
